module.exports = {"name":"bitdashvr","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.2.0","built":"2018-04-11","repo":"https://bitbucket.org/npaw/bitdashvr-adapter-js","libVersion":"6.2.0","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getDuration","getBitrate","getRendition","getIsLive","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 29
// module chunks = 0